import { useState, useEffect  } from "react"
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import {useLocation} from "react-router-dom"
import CboVarAlumnos from "./CboVarAlumnos";
import CboPeriodos from "./CboPeriodos";
import CboTipoLiq from "./CboTipoLiq";

const AluNovedades = ({ selectedValue, onChange, disabled }) => {

      
   const [codAlu, setCodALu] = useState("")
   const [codVar, setCodVar] = useState("")
   const [grupo, setGrupo] = useState(0);
   const [empresa, setEmpresa] = useState(0);
   const [nombVar, setNombVar] = useState("")  
   const [tipoliq, setTipoLiq] = useState(0)  
   const [perDesde, setPerDesde] = useState("")  
   const [perHasta, setPerHasta] = useState("")  
   const [varValor, setVarValor] = useState("")  
   
  const [variables, setVariables] = useState([])  

// para obligar a la actualización de la grilla de novedades, despues de un alta (o baja)
  const [cambio, setCambio] = useState(false);

   const [noteditable, setNotEditable] = useState(true)

 
// toast
   const [showToast, setShowToast] = useState(false);
   const [textoToast, setTextoToast] = useState("");

/*
   async function    handleOnChangeActivo(e){
    setSearchActivo(!searchactivo); 
    setSearchMessage("");
 }
 
*/


const location = useLocation();    

    

  useEffect(() => {

    

    var { unalumno } = location.state || {};
    console.log('Alumno a mostrar (novedades):', unalumno);


      var json3;
      var jsons3;
     var url3;
    let consulta = new Object();

   if (unalumno)
      {
        setCodALu(unalumno[0].Alu_IdAlu);
        setGrupo(unalumno[0].Gru_IdGru);
        setEmpresa(unalumno[0].Emp_IdEmp);
        consulta.alumno = unalumno[0].Alu_IdAlu;
        console.log("fetch nov alumno: ", unalumno[0].Alu_IdAlu);
        
        jsons3 = JSON.stringify(consulta);


        var options3 = {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json'

        },
        mode: 'cors',
        credential : 'include',
        body:  jsons3,
        
        };

        url3 = `${process.env.REACT_APP_API_URL}/nov/allalumnos`;
            
            
                      
                    fetch(url3, options3)
                    .then( response => response.json())
                    .then( data => {
                    
                    json3 = data.data;
                    console.log("nov/allalumnos-->", json3);
                    setVariables(json3);
                    // si hay datos, cargar en la ficha el primero
                    if (json3.length)
                    {
                      
                        setCodVar(json3[0].Val_IdVal);
                        setNombVar(json3[0].Val_Nombre);
                        setVarValor(json3[0].Nal_Value);
                        setPerDesde(json3[0].Per_IdPer);
                        setPerHasta(json3[0].Per_IdPer);
                        setTipoLiq(json3[0].Tli_IdTli);
                    }
                      
                    })
      }

    },[cambio]);
  


 /* Save */
  async function handleSave(e){
       // validar ???
       
       // llamo a la grabación del registro de alumno
       
        let unNovedad = new Object();
        unNovedad.alumno = codAlu;
        unNovedad.variable = codVar;
        unNovedad.perdesde = perDesde;
        unNovedad.perhasta = perHasta;
        unNovedad.valor = varValor; 
        console.log("Guardar novedades ", unNovedad);    
//        addAlumno(unAlumno);

      var url;
      var json;
      e.preventDefault()
      try { 
        setNotEditable(true);
        json = JSON.stringify(unNovedad);
          console.log(json);

             url = `${process.env.REACT_APP_API_URL}/nov/addalumno`;
 
        var options = {
          method: 'POST',
          headers: {
          'Content-Type': 'application/json'
          },
          mode: 'cors',
          credential : 'include',
          body:  json,
          
          };
        
        fetch(url, options)
        .then( response => response.json())
        .then( data => {
          
           json = data.data;
           console.log(json);
          // setNombre (json.nombre);
          // setApellido (json.apellido);            
          // setActivo (json.actvo);

/* toast */
setTextoToast("Novedad guardada");
setShowToast(true);
setCambio(!cambio);
setCodVar("");
setPerDesde(0);
setPerHasta(0);
setVarValor("");

        })
    } catch (error) {
        console.log(error);
        
    }



  }

const handleTipoLiqChange = (event) => {
    console.log("T Liq change:", event.target.value);
    setTipoLiq(Number(event.target.value));
   
  }; 


  async function handleNew(e)
  {
    ///setCodigo("");
    setPerDesde(0);
    setPerHasta(0);
    setNotEditable(false);
  }


  async function handleCancel(e){
 //   setCodigo("");
   
    setNotEditable(true);

  }  

  /* Editar */
  async function handleEdit(e){
    e.preventDefault()
    try {
   
      setNotEditable(false);
    } catch (error) {
        console.log(error);
        
    }
 
  }

  const handleVarAluChange = (event) => {
    setCodVar(event.target.value);
  };

  const handlePerDesdeChange = (event) => {
    setPerDesde(Number(event.target.value));
  };

  const handlePerHastaChange = (event) => {
    console.log("Nvo per hasta:", event.target.value);
    setPerHasta(Number(event.target.value));
  };

  
const handleGoVar = (index, event) =>
{
  if (noteditable)
  { 
  setCodVar(variables[index].Val_IdVal);
  setTipoLiq(variables[index].Tli_IdTli);
  setPerDesde(variables[index].Per_IdPer);
  setPerHasta(variables[index].Per_IdPer);
   setVarValor(variables[index].nal_value);
  }
}

function handleRemove(alumno, variable, periodo, ev)
{
  // Alu_IdAlu   Val_IdVal   Per_IdPer 
   ev.preventDefault()


   let unNovedad = new Object();
        unNovedad.alumno = alumno;
        unNovedad.variable = variable;
        unNovedad.periodo = periodo;
//        addAlumno(unAlumno);

      var url;
      var json;
     
      try { 
        setNotEditable(true);
        json = JSON.stringify(unNovedad);
          console.log(json);

             url = `${process.env.REACT_APP_API_URL}/nov/remalumno`;
 
        var options = {
          method: 'POST',
          headers: {
          'Content-Type': 'application/json'
          },
          mode: 'cors',
          credential : 'include',
          body:  json,
          
          };
        
        fetch(url, options)
        .then( response => response.json())
        .then( data => {
            console.log("novedad eliminada", json);
           json = data.data;
         
           setCambio(!cambio);

        })
    } catch (error) {
        console.log(error);
        
    }





}



           return (
      
<div >
 



    <div className="container-fluid">


    
    <div className="row">
              
        <div className="col-xs-12 col-lg-2 col-sm-12 col-md-6">
            <div className="form-group">
                <label htmlFor="exampleInputEmail1">Variable</label>
                <CboVarAlumnos 
                  selectedValue={codVar} 
                  onChange={handleVarAluChange} 
                  disabled={noteditable}
                />
            </div>
        </div>
      <div className="col-lg-offset-0 col-lg-2 col-xs-12 col-sm-6">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">Tipo Liquidación</label>
              <CboTipoLiq
                selectedValue={tipoliq} 
                onChange={handleTipoLiqChange} 
                disabled={noteditable}
               
              />
            </div>
          </div>  

        <div className="col-xs-12 col-lg-2 col-sm-12 col-md-6">
            <div className="form-group">
                <label htmlFor="exampleInputEmail1">Desde</label>
                <CboPeriodos 
                  selectedValue={perDesde} 
                  onChange={handlePerDesdeChange} 
                  disabled={noteditable}
                  grupo={grupo}
                  empresa={empresa}
                  tipoliq={tipoliq}
                />
            </div>
        </div>
        <div className="col-xs-12 col-lg-2 col-sm-12 col-md-6">
            <div className="form-group">
                <label htmlFor="exampleInputEmail1">Hasta</label>
                <CboPeriodos 
                  selectedValue={perHasta} 
                  onChange={handlePerHastaChange} 
                  grupo={grupo}
                  empresa={empresa}                  
                  disabled={noteditable}
                  tipoliq={tipoliq}
                />
            </div>
        </div>
        <div className="col-xs-12 col-lg-2 col-sm-12 col-md-6">
            <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Valor</label>
                  <input type="text" className="form-control" id="exampleInputEmail1" placeholder="" onChange={e => {setVarValor(e.target.value)}}  value={varValor} disabled={noteditable}/>
            </div>
        </div>

    </div>          

              <div className="row mb-1 border-primary">
                     
                     <div className="col  col-1 text-center border-info">
                       <button type="button" className="btn btn-info"  id="clear" onClick={handleNew} disabled={!noteditable} >Nuevo</button>
                     </div>

                     <div className="col  col-1 text-center border-info">
                     <button type="button" className="btn btn-info" id="edit" onClick={handleEdit} disabled={!noteditable}>Editar</button>
                     </div>

                     <div className="col  col-1 text-center border-info">
                     <button type="button" className="btn btn-info" id="grabar" onClick={handleSave} disabled={noteditable}>Guardar</button>
                     </div>
                     <div className="col  col-1 text-center border-info">
                     <button type="button" className="btn btn-info" id="cancelar"  onClick={handleCancel} disabled={noteditable}>Cancelar</button>
                     </div>


              </div>
            

  <table className="table table-striped table-primary table-hover m-3 p-2">
  <thead>
    <tr className="row" >
      <th className="col-2" >Período</th>
      <th className="col-2" >Variable</th>
      <th className="col-1" >Valor</th>
      <th className="col-1" ></th>
    </tr>
  </thead>
  <tbody>
{ 


   variables.map (( unolista, index ) => (
    <tr key={index+'_row'}  className="row"  onClick={(event) => handleGoVar(index, event) }>
              <td key={index+'_period'} className="col-2" >
                { unolista.Per_Nombre } 
              </td> 

              <td key={index+'_nombre'} className="col-2" >
                { unolista.Val_Descrip } 
              </td> 
              <td key={index+'_valor'} className="col-1" >
                { unolista.Nal_Value } 
              </td> 

              <td key={index+'_remnov'} className="col-1" >
               
                 <button type="button" className="btn btn-info"  onClick={(event) => handleRemove(unolista.Alu_IdAlu, unolista.Val_IdVal, unolista.Per_IdPer,  event) } >Eliminar</button>
              </td>     

     </tr>
   )
   )
   }

</tbody>
</table>

</div>

      <ToastContainer position="bottom-end">
        <Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide>
          
          <Toast.Body>{textoToast}</Toast.Body>
        </Toast>
        </ToastContainer>










<div className="toast-container position-fixed bottom-0 end-0 p-3">
  <div id="liveToastmsg" className="toast" role="alert" aria-live="assertive" aria-atomic="true">

    <div className="toast-body">
      
    </div>
  </div>
</div>













               </div>
          );
   



};

export default AluNovedades;